import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { HeatingCircuitViewModel, InstallationFeaturesStore } from '@store';

import { NO_VALUE } from '@pipes';
import { UIService } from '@services';
import { InstallationService } from '../../../services/installation.service';

import {
  FeaturesDetailsOverlayTypeEnum,
  SingleRoomControlOverlayTypeEnum
} from '../../../../+installations/installation/installation-overlay.model';

@Component({
  selector: 'app-room-related-heating-circuits',
  templateUrl: './room-related-heating-circuits.component.html',
  styleUrls: ['./room-related-heating-circuits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomRelatedHeatingCircuitsComponent implements OnInit {
  installationId: number;
  gatewaySerial: string;
  heatingCircuits$: Observable<HeatingCircuitViewModel[]>;
  showOptimizationInfo$: Observable<boolean>;
  showNoSmartClimateComponentsInfo$: Observable<boolean>;

  readonly noValue = NO_VALUE;

  @Input() roomId: string;

  constructor(
    public installationFeaturesStore: InstallationFeaturesStore,
    public uiService: UIService,
    private installationService: InstallationService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });

    this.activatedRoute.params.subscribe((param) => {
      this.installationId = +param['id'];
    });
    this.heatingCircuits$ = this.installationFeaturesStore.getRoomRelatedHeatingCircuits(
      this.roomId
    );
    this.showOptimizationInfo$ = this.installationFeaturesStore.getRoomShowOptimizationInfo(
      this.roomId
    );
    this.showNoSmartClimateComponentsInfo$ = this.installationFeaturesStore.getRoomShowNoSmartClimateComponentsInfo(
      this.roomId
    );
  }

  openSrcSettingsOverlay(): void {
    this.uiService.openSingleRoomControlOverlay(
      SingleRoomControlOverlayTypeEnum.SingleRoomControlSettings,
      this.installationId,
      this.gatewaySerial
    );

    setTimeout(() => {
      const srcOverlay = document.getElementsByTagName('app-src-overlay');
      if (srcOverlay?.length) {
        srcOverlay[0].scrollTop = 0;
      } 
    });
  }

  openHCOverlay(circuitId: string): void {
    this.installationService.selectedCircuitId$.next(circuitId);
    this.uiService.openActiveOverlay(FeaturesDetailsOverlayTypeEnum.HeatingCircuit);
  }
}
